import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentFacadeService } from './environment.facade.service';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  constructor(
    private http: HttpClient,
    private environmentFacade: EnvironmentFacadeService,
  ) {}

  getRoles(): Observable<any> {
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/auth/current-user-permissions`;
    return this.http.get<any>(url, { withCredentials: true }).pipe(
      map((res: any) => JSON.stringify(res?.data?.userPermissions || res?.userPermissions || res)),
    );
  }
}
